// extracted by mini-css-extract-plugin
export var transportTitle = "transport-title-module--transportTitle--09127";
export var transportTitleActionButton = "transport-title-module--transportTitleActionButton--9d7d3";
export var transportTitleContent = "transport-title-module--transportTitleContent--12b4b";
export var transportTitleDescription = "transport-title-module--transportTitleDescription--1d942";
export var transportTitleImageBox = "transport-title-module--transportTitleImageBox--bcd67";
export var transportTitleLabel = "transport-title-module--transportTitleLabel--c0821";
export var truncateContent = "transport-title-module--truncate-content--a97e4";